<template>
    <div
        class="container pb-4 remote-readiness-admin"
        style="max-width: 768px;margin: 0 auto;"
    >
        <div class="row pt-4 pb-4">
            <div class="col-12">
                <div class="remote-readiness-admin__title">
                    Remote readiness
                </div>
                <div class="remote-readiness-admin__desc">
                    General overview of of employees daily compliance to check-in. <br/>
                    Only visible to admins.
                </div>
            </div>
        </div>
        <remote-readiness-all></remote-readiness-all>
    </div>
</template>

<script>
export default {
    name: "RemoteReadiness"
};
</script>

<style scoped lang="scss">
.remote-readiness-admin {
    margin-top: 65px !important;

    @media (max-width: 768px) {
        margin-top: 12px !important;
    }

    &__title {
        color: #303030;
        font-family: Lato;
        font-size: 38px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 53.2px;
        text-align: center;
        @media (max-width: 768px) {
            font-size: 24px;
            text-align: left;
            line-height: 44px;
        }
    }

    &__desc {
        color: #606064;
        font-family: "Open Sans";
        font-size: 20px;
        letter-spacing: 0;
        line-height: 28px;
        text-align: center;

        @media (max-width: 768px) {
            font-size: 14px;
            text-align: left;
            line-height: 20px;
        }
    }
}
</style>
